module.exports = __webpack_public_path__ + "img/icon-upload-file-small.888c23d4.svg";